// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Poppins_079ad9', '__Poppins_Fallback_079ad9'","fontStyle":"normal"},"className":"__className_079ad9","variable":"__variable_079ad9"};